import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
import appTypes from '../app/types';
const createInitialState = () => ({
    metadata: null,
    contacts: [],
    companies: [],
    currentContactId: null,
    firstSearch: true,
    requestId: uuid(),
});
const initialState = createInitialState();
const slice = createSlice({
    name: 'CONTACT',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => createInitialState());
    },
    reducers: {
        setSearchResult(state, { payload }) {
            var _a, _b, _c;
            state.metadata = (_a = payload.metadata) !== null && _a !== void 0 ? _a : null;
            state.contacts = (_b = payload.contacts) !== null && _b !== void 0 ? _b : [];
            state.companies = (_c = payload.companies) !== null && _c !== void 0 ? _c : [];
            state.firstSearch = false;
        },
        setInvalidateStatus(state, { payload }) {
            state.invalidated = payload;
        },
        setCurrentContactId(state, { payload }) {
            state.currentContactId = payload;
        },
        clearSearchResult() {
            return createInitialState();
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
